import { useApolloClient } from '@apollo/client'
import { TaskActivityDocument } from 'generated/resources/graphql'

import { useActivity } from 'modules/core/lib/activities/activity'
import i18n from 'modules/core/lib/i18n'

import FormRender from 'modules/forms/components/FormRender'
import { FormResponsesSidepanel } from 'modules/forms/components/FormResponses/FormRenderResponses/FormResponsesSidepanel'
import { TaskCustomComponent, TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'

const FillFormTaskContent: TaskCustomComponent<'FormsMyMembership'> = ({ taskable }) => {
  const { closeActivity } = useActivity()
  const apolloClient = useApolloClient()

  if (!taskable) {
    return null
  }

  const membershipId = taskable.stringId
  const form = taskable.materializedForm?.surveyForm || taskable.materializedForm?.trainingForm
  const formId = form?.id
  const resourceType = form?.resourceType
  const isCompleted = taskable.status === 'completed'
  const materializedFormResourceType = taskable.materializedForm?.resourceType ?? ''

  if (!formId || !resourceType) {
    return null
  }

  return isCompleted ? (
    <FormResponsesSidepanel
      membershipId={membershipId}
      materializedFormResourceType={materializedFormResourceType}
      formId={formId}
      isOpen
      onClose={closeActivity}
      resourceType={resourceType}
    />
  ) : (
    <FormRender
      formId={formId}
      resourceType={resourceType}
      isOpen
      onClose={closeActivity}
      onSubmitSuccess={async () => {
        await apolloClient.refetchQueries({
          include: [TaskActivityDocument],
        })
        closeActivity()
      }}
      mode="answer"
      membershipId={membershipId}
    />
  )
}

export const FillFormTaskDefinition: TaskDefinition<'FormsMyMembership'> = {
  taskableTypename: 'FormsMyMembership',
  initialState: {},
  component: FillFormTaskContent,
  renderWithoutOneModal: true,
  getUrl: ({ info }) => {
    return info.url || ''
  },
  getTitle: ({ info, affecteeName }) => {
    const surveyName = info.materializedForm?.formTitle

    if (affecteeName && affecteeName.length > 1) {
      return i18n.t('tasks.inbox.titles.survey_affectee', {
        surveyName,
        affecteeName,
      })
    }

    return i18n.t('tasks.inbox.titles.survey_own', {
      surveyName,
    })
  },
}
